<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="cont"></a><a id="page_vii"></a>Contents</h2>
<p class="tocfm"><em><a class="nounder" href="#/xhtml/pre">Preface and Acknowledgments</a></em></p>
<p class="tocfma"><a class="nounder" href="#/xhtml/int">Introduction: A Black Founder’s Many Worlds</a></p>
<p class="tocc"><a class="nounder" href="#/xhtml/ch01">1 “For Zion’s Sake … I Will Not Rest”</a></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">2 Gospel Labors</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3 The Year of the Fever, Part 1: A (Deceptively) Simple Narrative of the Black People</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4 The Year of the Fever, Part 2: Allen’s Antislavery Appeal</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5 “We Participate in Common”: Allen’s Role as a Black Mediator</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6 A Liberating Theology: Establishing the AME Church</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">7 Stay or Go? Allen and African Colonization</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">8 Allen Challenged: Shadow Politics and Community Conflict in the 1820s</span></p>
<p class="tocc"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">9 A Black Founder’s Expanding Visions</span></p>
<p class="toccc"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">10 Last Rights</span></p>
<p class="tocfm"><span class="nounder" href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion: Richard Allen and the Soul of Black Reform</span></p>
<p class="tocfma"><em><span class="nounder" href="#/xhtml/note" title="Link target outside of Sample">Notes</span></em></p>
<p class="tocfm"><em><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span></em></p>
<p class="tocfm"><em><span class="nounder" href="#/xhtml/ata" title="Link target outside of Sample">About the Author</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?4b2dae40